let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cpH2W")).then(() => parcelRequire('h6FWY'));